var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Button from "@irati/ui/src/Button";
import { Hr } from "@irati/ui/src/Layout";
export var RefWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: max-content;\n  max-height: max-content;\n"], ["\n  max-width: max-content;\n  max-height: max-content;\n"])));
export var InnerRefWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: 999;\n"], ["\n  z-index: 999;\n"])));
export var ToggleButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 10px;\n  ", "\n"], ["\n  padding: 10px;\n  ", "\n"])), function (_a) {
    var open = _a.open, theme = _a.theme;
    return open && "box-shadow: 0 0 0 1px " + theme.colors.greys.mediumDark + ";";
});
export var StyledHr = styled(Hr)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var top = _a.top;
    return (top ? "10px 0 0 0" : "0 0 10px 0");
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
